import React from 'react';

import { Title } from '@components/Title';

import { useThemeGetter } from '@hooks';

import { Characteristic } from '@components/Characteristic';
import { FieldIcon, LocationIcon, PeriodIcon } from '@assets/icons';
import { parseDateForJobPeriod } from '@utils';
import { TextBlock } from '@components/TextBlock';
import {
  DividingLine,
  JobDescContainer,
  JobCommonContainer,
  JobDescriptionContainer,
} from './JobDescription.styled';

import { JobDescriptionProps } from './JobDescription.types';

export const JobDescription = ({
  company,
  endDate,
  jobTitle,
  industry,
  location,
  startDate,
  description,
  locationType,
  employmentType,
}: JobDescriptionProps) => {
  const {
    theme: { BlockShadow, Title: TitleColor, Text: TextColor },
  } = useThemeGetter();

  return (
    <JobDescriptionContainer shadow={BlockShadow}>
      <JobCommonContainer>
        <Title text={company} size={3} color={TitleColor} align="left" />
        <Title
          text={`${jobTitle} — ${employmentType}`}
          size={2}
          color={TitleColor}
          align="left"
          font="SignikaLight"
        />
      </JobCommonContainer>
      <DividingLine borderColor={TitleColor} />
      <JobDescContainer>
        <Characteristic
          text={industry}
          textColor={TextColor}
          icon={<FieldIcon />}
        />
        <Characteristic
          text={`${location} — ${locationType}`}
          textColor={TextColor}
          icon={<LocationIcon />}
        />
        <Characteristic
          text={`${parseDateForJobPeriod(startDate)} — ${parseDateForJobPeriod(
            endDate,
          )}`}
          textColor={TextColor}
          icon={<PeriodIcon />}
        />
      </JobDescContainer>
      <DividingLine borderColor={TitleColor} />
      <JobDescContainer>
        {description.mainDesc.map((one) => (
          <TextBlock
            size={1.5}
            key={one}
            text={one}
            align="left"
            indent={30}
            color={TextColor}
          />
        ))}
        {description.listDesc.map((one) => (
          <TextBlock
            size={1.5}
            key={one}
            text={`— ${one}`}
            align="left"
            indent={30}
            color={TextColor}
          />
        ))}
      </JobDescContainer>
    </JobDescriptionContainer>
  );
};
